interface IconProps {
  color?: string;
  className?: string;
  onClick?: () => void;
};

export const ArrowRight = ({ color = 'var(--link-icon__color)', ...props }: IconProps) => {
  return (
    <svg className={props.className} width="14" height="11" viewBox="0 0 14 11" fill="none">
      <path stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M12.5664 5.39475L1 5.32544" />
      <path stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M9.38672 9.39465L12.9998 5.39465" />
      <path stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M9.38672 1.39465L12.9998 5.39465" />
    </svg>    
  );
};
ArrowRight.displayName = 'ArrowRight';

export const ArrowDown = ({ color = 'var(--link-icon__color)', ...props }: IconProps) => {
  return (
    <svg className={props.className} width="11" height="7" viewBox="0 0 11 7" fill="none">
      <path stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M1.19336 1.58789L5.19336 5.20098" />
      <path stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M9.19336 1.58789L5.19336 5.20098" />
    </svg>    
  );
};
ArrowDown.displayName = 'ArrowDown';

export const ArrowExternal = ({ color = 'var(--link-icon__color)', ...props }: IconProps) => {
  return (
    <svg className={props.className} width={9} height={9} viewBox="0 0 9 9" fill="none" >
      <path fill={color} d="m8.126 1.413-.077 5.291a.883.883 0 0 1-.255.615.883.883 0 0 1-.614.255.824.824 0 0 1-.854-.854l.054-3.202-4.338 4.339c-.341.341-.89.351-1.22.021-.33-.33-.32-.879.021-1.22L5.182 2.32l-3.232.055a.824.824 0 0 1-.854-.854.897.897 0 0 1 .885-.885L7.27.559a.824.824 0 0 1 .855.854Z" />
    </svg>
  );
};
ArrowExternal.displayName = 'ArrowExternal';

export const Globe = ({ color = '#fff', ...props }: IconProps) => {
  return (
    <svg className={props.className} width={22} height={20} fill="none" >
      <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10 19a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9M1.51 7h16.87M1.51 13H10" />
      <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M14 10c0-2.764-.723-5.528-2.167-7.94a2.114 2.114 0 0 0-3.665 0c-2.89 4.825-2.89 11.056 0 15.881a2.125 2.125 0 0 0 1.833 1.06M21 15.625 19.875 14.5l-1.125 1.125M12.75 16.375l1.125 1.125L15 16.375" />
      <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13.875 17.5v-3a1.5 1.5 0 0 1 1.5-1.5h2.25M19.875 14.5v3c0 .825-.675 1.5-1.5 1.5h-2.242" />
    </svg>
  );
};
Globe.displayName = 'Globe';

export const Twitter = ({ color = '#fff', ...props }: IconProps) => {
  return (
    <svg className={props.className} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path fill={color} d="M11.905 8.46953L19.3512 0H17.5869L11.1184 7.35244L5.95583 0H0L7.80863 11.1192L0 20H1.76429L8.59099 12.2338L14.0442 20H20L11.905 8.46953ZM9.48775 11.2168L8.69536 10.1089L2.40053 1.30146H5.11084L10.1925 8.41197L10.9815 9.51988L17.5861 18.7619H14.8758L9.48775 11.2168Z" />
    </svg>
  );
};
Twitter.displayName = 'Twitter';

export const LinkedIn = ({ color = '#fff', ...props }: IconProps) => {
  return (
    <svg className={props.className} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path fill={color} d="M10.7545 9.02087V8.98991C10.748 9.00036 10.7411 9.01082 10.7342 9.02087H10.7545Z" />
      <path fill={color} d="M18.5214 0H1.47739C0.661608 0 0 0.641763 0 1.43271V18.5677C0 19.3582 0.661608 20 1.47739 20H18.5214C19.3384 20 20 19.3578 20 18.5677V1.43271C20 0.641361 19.338 0 18.5214 0ZM6.06212 16.7425H3.04138V7.71161H6.06212V16.7425ZM4.55195 6.47794H4.53171C3.51846 6.47794 2.86292 5.78431 2.86292 4.91777C2.86292 4.03193 3.5387 3.35759 4.57178 3.35759C5.60526 3.35759 6.24097 4.03193 6.2612 4.91777C6.2612 5.78431 5.60486 6.47794 4.55195 6.47794ZM16.955 16.7425H13.9342V11.91C13.9342 10.6964 13.4972 9.86811 12.4042 9.86811C11.5699 9.86811 11.0729 10.4266 10.854 10.9663C10.7743 11.1589 10.7549 11.4283 10.7549 11.6985V16.7421H7.73414C7.73414 16.7421 7.7738 8.55764 7.73414 7.71121H10.7549L10.7545 8.98991C11.1559 8.37468 11.8742 7.49809 13.4778 7.49809C15.465 7.49809 16.9554 8.78926 16.9554 11.5634L16.955 16.7425Z" />
    </svg>
  );
};
LinkedIn.displayName = 'LinkedIn';

export const GitHub = ({ color = '#fff', ...props }: IconProps) => {
  return (
    <svg className={props.className} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path fill={color} fillRule="evenodd" clipRule="evenodd" d="M10 0C4.47768 0 0 4.58953 0 10.255C0 14.7865 2.86607 18.626 6.83929 19.9832C7.33929 20.077 7.52232 19.76 7.52232 19.4876C7.52232 19.2421 7.51339 18.5992 7.50893 17.742C4.72768 18.3626 4.13839 16.3669 4.13839 16.3669C3.68304 15.1838 3.02679 14.8669 3.02679 14.8669C2.12054 14.2284 3.09375 14.2418 3.09375 14.2418C4.09821 14.3133 4.625 15.2999 4.625 15.2999C5.51786 16.867 6.96429 16.416 7.53571 16.1526C7.625 15.4919 7.88393 15.0365 8.16964 14.782C5.95089 14.5231 3.61607 13.6436 3.61607 9.7148C3.61607 8.5942 4.00446 7.67898 4.64286 6.96465C4.54018 6.70571 4.19643 5.66101 4.74107 4.25022C4.74107 4.25022 5.58036 3.97342 7.49107 5.29939C8.29018 5.0717 9.14286 4.96008 9.99554 4.95562C10.8437 4.96008 11.7009 5.0717 12.5 5.29939C14.4107 3.97342 15.2455 4.25022 15.2455 4.25022C15.7902 5.66101 15.4464 6.70571 15.3438 6.96465C15.9821 7.68344 16.3705 8.59867 16.3705 9.7148C16.3705 13.6525 14.0313 14.5186 11.8036 14.7731C12.1607 15.0901 12.4821 15.7151 12.4821 16.6705C12.4821 18.0411 12.4687 19.1483 12.4687 19.4832C12.4687 19.7555 12.6473 20.077 13.1563 19.9743C17.1384 18.6215 20 14.782 20 10.255C20 4.58953 15.5223 0 10 0Z" />
    </svg>
  );
};
GitHub.displayName = 'GitHub';

export const Checkmark = ({ color = '#fff', ...props }: IconProps) => {
  return (
    <svg className={props.className} width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path stroke={color} d="M6.40354 8.78977L4.61377 7" strokeLinecap="round" strokeLinejoin="round"/>
      <path stroke={color} d="M9.38627 5.80676L6.40332 8.78972" strokeLinecap="round" strokeLinejoin="round"/>
      <circle stroke={color} cx="7" cy="7" r="6.5" />
    </svg>
  );
};
Checkmark.displayName = 'Checkmark';